import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../redux/hooks";
import { RootState } from "../redux/store";

export const PrivateRoutes = () => {
  const { token } = useAppSelector((state: RootState) => state.auth);

  return token ? <Outlet /> : <Navigate to="/auth/login" />;
};
